import React, { Component } from 'react';
import { Table, Row, Alert, Button, message, Spin } from 'antd';
import moment from 'moment';
import './index.scss';
import imgSave from "../../saveImg";
import { data1_1 } from './data';
import Auth from "../../Auth";
import Compared from "../../Compared";
import IsLableAuth from "../../IsLableAuth";
import FileSaver from "file-saver";
import { Prompt } from 'react-router-dom';
import MonthPicker from '@/template/MonthPicker'
import { compute, fillData, saveAllData } from './compute'

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: false,
            loadingSave: false,
            print: false,
            isEdit: false
        }
    }

    componentDidMount() {
        //在关闭页面时弹出确认提示窗口
        window.addEventListener('beforeunload', this.handleWindowClose);
        this.setState({ loading: true });
        this.getDateData(this.state.date);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.print != this.state.print) {
            this.setState({ print: nextProps.print });
        }
    }
    handleWindowClose = (ev) => {
        const confirmationMessage = '数据还未保存,确定要离开吗?';
        (ev || window.event).returnValue = confirmationMessage;
        if (this.state.isEdit) {
            return confirmationMessage;
        }
    }
    componentWillUnmount() {
        if (this.state.isEdit) {
            window.οnbefοreunlοad = function () {
                return ("数据还未保存,确定要离开吗?");
            }
        }
        console.log('卸载');
        window.removeEventListener('beforeunload', this.handleWindowClose);
    }


    computeNum = (data) => {
        const _data = compute(data);
        this.setState({
            data: _data,
        }, () => {
            this.onSave();
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
        this.setState({ isEdit: true });
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data1_1);
        let data = JSON.parse(dataBegin);
        fetch(`/kpiInfoAll?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.kpi && x.data.kpi.length > 0) {
                data = x.data.kpi;
            }
            data = fillData(data, { ...x.data, date });

            this.setState({ loading: false }, () => {
                this.computeNum(data)
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addKpiInfo', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status != 1) message.error(x.msg);

        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {
        this.setState({ print: true, loading: true }, () => {
            imgSave('table1_1', 1.5, '1.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `KPI - MTD/YTD/FST 关键绩效指数 - 月累计/年累计/预测${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    render() {
        const { isEdit, data, print, date, loading } = this.state;
        const width = document.body.offsetWidth > 3470 ? document.body.offsetWidth - 3100 : 425;
        const inputIndex = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 25, 26, 27, 29, 30, 31, 32];
        const percentData = [2, 10, 12, 14, 16, 18, 20, 22, 24];
        const totalData = [8, 22, 23, 24, 28];
        const columns = [{
            align: "center",
            title: <div>Key Performance Indicator <br /> 关键绩效指数</div>,
            dataIndex: 'name',
            key: 'name',
            width,
            fixed: print ? false : "left",
            render: (text, record, index) => {
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'MTD 月累计',
            align: "center",
            width: 1050,
            children: [{
                title: <div>Actual <br /> 实际</div>,
                dataIndex: 'actual',
                key: 'actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = [`MTD 月累计-Actual 实际`];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'actual', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : "number" }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Forecast <br /> 预测</div>,
                dataIndex: 'prediction',
                key: 'prediction',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = [`MTD 月累计-Forecast 预测`];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2) == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2)) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'prediction', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : "number" }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Budget <br /> 预算</div>,
                dataIndex: 'budget',
                key: 'budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = [`MTD 月累计-Budget 预算`];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'budget', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : "number" }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Last Year <br /> 去年</div>,
                dataIndex: 'last_year',
                key: 'last_year',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = [`MTD 月累计-Last Year 去年`];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'last_year', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : "number" }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: '% Change 变化百分比',
                align: "center",
                width: 360,
                children: [{
                    title: <div>Act vs. Fcst. <br /> 实际对比预测</div>,
                    dataIndex: 'actual_prediction',
                    key: 'actual_prediction',
                    align: "center",
                    width: 120,
                    render: (text, record, index) => {
                        const title = [`MTD 月累计-% Change 变化百分比 `, 'Act vs. Fcst. 实际对比预测'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'actual_prediction', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'actual_prediction', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                }, {
                    title: <div>Act vs. Bgt. <br /> 实际对比预算</div>,
                    dataIndex: 'actual_budget',
                    key: 'actual_budget',
                    align: "center",
                    width: 120,
                    render: (text, record, index) => {
                        const title = [`MTD 月累计-% Change 变化百分比 `, 'Act vs. Bgt. 实际对比预算'];
                        // const props = {
                        //     text, index, type: 'percent', name: "actual_budget", onChange: this.onChange, totalIndex: '',
                        //     compared: {
                        //         title,
                        //         record,
                        //         sqlName: "hr_4_1_3"
                        //     }
                        // };
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'actual_budget', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'actual_budget', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                }, {
                    title: <div>Act vs. LY <br /> 实际对比去年</div>,
                    width: 120,
                    dataIndex: 'actual_last_year',
                    key: 'actual_last_year',
                    align: "center",
                    render: (text, record, index) => {
                        const title = [`MTD 月累计-% Change 变化百分比 `, 'Act vs. LY 实际对比去年'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'actual_last_year', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'actual_last_year', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                },],
            }],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 750,
            children: [{
                title: <div>Actual <br /> 实际</div>,
                dataIndex: 'year_actual',
                key: 'year_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['YTD 年累计-Actual 实际'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'year_actual', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? "percent" : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Budget <br /> 预算</div>,
                dataIndex: 'year_budget',
                key: 'year_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['YTD 年累计-Budget 预算'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(2) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'year_budget', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? "percent" : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Last Year <br /> 去年</div>,
                dataIndex: 'year_last_year',
                key: 'year_last_year',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['YTD 年累计-Last Year 去年'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(2) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'year_last_year', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? "percent" : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: '% Change 变化百分比',
                align: "center",
                width: 360,
                children: [{
                    title: <div>Act vs. Bgt. <br /> 实际对比预算</div>,
                    dataIndex: 'year_actual_budget',
                    key: 'year_actual_budget',
                    align: "center",
                    width: 120,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计-% Change 变化百分比', 'Act vs. Bgt. Act vs. Bgt. 实际对比预算'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'year_actual_budget', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_actual_budget', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                }, {
                    title: <div>Act vs. LY <br /> 实际对比去年</div>,
                    width: 120,
                    dataIndex: 'year_actual_last_year',
                    key: 'year_actual_last_year',
                    align: "center",
                    render: (text, record, index) => {
                        const title = ['YTD 年累计-% Change 变化百分比', 'Act vs. LY 实际对比去年'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'year_actual_last_year', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_actual_last_year', title, sqlName: "kpis", name: record.name, type: "percent" }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                },],
            }],
        }, {
            title: '3-Month-Rolling Forecast 后三个月滚动预测',
            align: "center",
            width: 750,
            children: [{
                title: <div>Forecast  <br /> 预测</div>,
                dataIndex: 'three_actual',
                key: 'three_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['3-Month-Rolling Forecast 后三个月滚动预测', 'Forecast 预测'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'three_actual', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Budget <br /> 预算</div>,
                dataIndex: 'three_budget',
                key: 'three_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['3-Month-Rolling Forecast 后三个月滚动预测', 'Budget 预算'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'three_budget', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Last Year <br /> 去年</div>,
                dataIndex: 'three_last_year',
                key: 'three_last_year',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['3-Month-Rolling Forecast 后三个月滚动预测', 'Last Year 去年'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(2) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'three_last_year', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: '% Change 变化百分比',
                align: "center",
                width: 360,
                children: [{
                    title: <div>Fcst vs. Bgt. <br /> 预测对比预算</div>,
                    dataIndex: 'three_actual_budget',
                    key: 'three_actual_budget',
                    align: "center",
                    width: 120,
                    render: (text, record, index) => {
                        const title = ['3-Month-Rolling Forecast 后三个月滚动预测', '% Change 变化百分比', 'Fcst vs. Bgt. 预测对比预算 '];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'three_actual_budget', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'three_actual_budget', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                }, {
                    title: <div>Fcst vs. LY <br /> 预测对比去年</div>,
                    width: 120,
                    dataIndex: 'three_actual_last_year',
                    key: 'three_actual_last_year',
                    align: "center",
                    render: (text, record, index) => {
                        const title = ['3-Month-Rolling Forecast 后三个月滚动预测', '% Change 变化百分比', 'Fcst vs. LY 预测对比去年 '];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'three_actual_last_year', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'three_actual_last_year', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                },],
            }],
        }, {
            title: 'Whole Year Forecast Total 整年预测',
            align: "center",
            width: 750,
            children: [{
                title: <div>Forecast  <br /> 预测</div>,
                dataIndex: 'whole_actual',
                key: 'whole_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['Whole Year Forecast Total 整年预测', 'Forecast 预测'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'whole_actual', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Budget <br /> 预算</div>,
                dataIndex: 'whole_budget',
                key: 'whole_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['Whole Year Forecast Total 整年预测', 'Budget 预算'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(2) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'whole_budget', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: <div>Last Year <br /> 去年</div>,
                dataIndex: 'whole_last_year',
                key: 'whole_last_year',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (index == 24) return '';
                    const title = ['Whole Year Forecast Total 整年预测', 'Last Year 去年'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : Math.abs(Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index, key: 'whole_last_year', title, sqlName: "kpis", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }, {
                title: '% Change 变化百分比',
                align: "center",
                width: 360,
                children: [{
                    title: <div>Fcst vs. Bgt. <br /> 预测对比预算</div>,
                    dataIndex: 'whole_actual_budget',
                    key: 'whole_actual_budget',
                    align: "center",
                    width: 120,
                    render: (text, record, index) => {
                        const title = ['Whole Year Forecast Total 整年预测', '% Change 变化百分比', 'Fcst vs. Bgt. 预测对比预算'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'whole_actual_budget', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'whole_actual_budget', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                }, {
                    title: <div>Fcst vs. LY <br /> 预测对比去年</div>,
                    width: 120,
                    dataIndex: 'whole_actual_last_year',
                    key: 'whole_actual_last_year',
                    align: "center",
                    render: (text, record, index) => {
                        const title = ['Whole Year Forecast Total 整年预测', '% Change 变化百分比', 'Fcst vs. Bgt. 预测对比预算'];
                        if (text < 0) {
                            return (
                                <Compared data={{ index, key: 'whole_actual_last_year', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                    <div className={`table-color table-owe  ${totalData.includes(index) ? 'table-color-footer' : ''}`}>({((Math.abs(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Math.abs(text || "0") * 100).toFixed(2).toLocaleString()) + '%'})</div>
                                </Compared >
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'whole_actual_last_year', title, sqlName: "kpis", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>{((Number(text || "0") * 100).toFixed(2).toLocaleString() == "-0" ? "0" : (Number(text || "0") * 100).toFixed(2).toLocaleString()) + '%'}</div>
                            </Compared >
                        )
                    }
                },],
            }],
        }];
        return (
            <Spin spinning={this.state.loading}>
                <div className="table">
                    <Row className="title" id="table1_1" style={{ width: this.state.print ? 3520 : 'auto' }}>
                        <Row>1.1 KPI - MTD/YTD/FST 关键绩效指数 - 月累计/年累计/预测</Row>
                        <Row className="table-month">
                            <MonthPicker date={this.state.date}
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }} />
                            <Auth isAdmin={true}>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.setState({ loading: true }, async () => {
                                            await saveAllData(date);
                                            this.setState({ loading: false });
                                        })
                                    }}
                                >
                                    保存所有酒店数据
                                </Button>
                            </Auth>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            className="content"
                            id="table"
                            bordered
                            pagination={false}
                            style={{ width: this.state.print ? 3470 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3470, y: 550 }}
                            rowKey={(record, index) => {
                                return record.id || record.name
                            }}
                        />

                    </Row>
                    <Row className="table-footer-btn">
                        <Alert
                            message={
                                <div>
                                    表格关联
                                    <IsLableAuth auth="read_2_1" {...this.props} path="/table/2_1">2.1</IsLableAuth> -
                                    <IsLableAuth auth="read_2_2" {...this.props} path="/table/2_2">2.2</IsLableAuth> -
                                    <IsLableAuth auth="read_2_3" {...this.props} path="/table/2_3">2.3</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.onExpoetExcel();
                                });
                            }}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_1">
                            <Button
                                type="primary"
                                // style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            {/* <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button> */}
                        </Auth>
                    </Row>
                </div>
                {
                    isEdit && <Prompt
                        message="数据还未保存,确定要离开吗?"
                    />
                }
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-1KeyPerformanceIndicator/index.js